import { Box, Card, Toolbar as MUIToolbar } from '@mui/material';
import React from 'react';

function Toolbar({ children }) {
  return (
    <Box>
      <Card>
        <MUIToolbar>{children}</MUIToolbar>
      </Card>
    </Box>
  );
}

export default Toolbar;
